import createIcon from '../../createIcon';

/**
 * @component @name FlightLand
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDE5LjVIMjEuNVYyMS41SDIuNVYxOS41Wk0xOS4zNCAxNi4zNUMyMC4xNCAxNi41NiAyMC45NiAxNi4wOSAyMS4xOCAxNS4yOUMyMS4zOSAxNC40OSAyMC45MiAxMy42NyAyMC4xMiAxMy40NUwxNC44MSAxMi4wM0wxMi4wNSAzLjAxTDEwLjEyIDIuNVYxMC43OEw1LjE1IDkuNDVMNC4yMiA3LjEzTDIuNzcgNi43NFYxMS45MUwxOS4zNCAxNi4zNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlightLand = createIcon('FlightLand', [
  [
    'path',
    {
      d: 'M2.5 19.5H21.5V21.5H2.5V19.5ZM19.34 16.35C20.14 16.56 20.96 16.09 21.18 15.29C21.39 14.49 20.92 13.67 20.12 13.45L14.81 12.03L12.05 3.01L10.12 2.5V10.78L5.15 9.45L4.22 7.13L2.77 6.74V11.91L19.34 16.35Z',
      key: '1ruj9h',
    },
  ],
]);

export default FlightLand;
